import { render, staticRenderFns } from "./CountryAbout.vue?vue&type=template&id=5bdf4f3a&scoped=true"
import script from "./CountryAbout.vue?vue&type=script&lang=js"
export * from "./CountryAbout.vue?vue&type=script&lang=js"
import style0 from "./CountryAbout.vue?vue&type=style&index=0&id=5bdf4f3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdf4f3a",
  null
  
)

export default component.exports